<template>
  <v-navigation-drawer app v-model="DRAWER_STATE" :mini-variant="!DRAWER_STATE" :width="sidebarWidth"
    :permanent="$vuetify.breakpoint.lgAndUp" :mini-variant-width="sidebarMinWidth"
    :class="{ 'drawer-mini': !DRAWER_STATE }" :bottom="isMobile" :left="!isMobile">
    <v-list>
      <template v-for="(item, i) in items">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <span style="padding-left: 32px" class="text-body-1 subheader"
              :class="item.heading && DRAWER_STATE ? 'show ' : 'hide'">
              {{ item.heading }}
            </span>
          </v-col>
          <v-col cols="6" class="text-center"></v-col>
        </v-row>
        <v-divider v-else-if="item.divider" :key="i" dark class="my-4"></v-divider>
        <v-list-group color="primary" v-else-if="item.children" :key="item.title" v-model="item.model">
          <template v-slot:prependIcon>
            <v-tooltip right v-if="!DRAWER_STATE">
              <template v-slot:activator="{ on, attrs }">
                <v-icon size="24" class="mr-0" color="greyTint" v-bind="attrs" v-on="on">{{ item.icon }}</v-icon>
              </template>
              <span> {{ item.title }}</span>
            </v-tooltip>
            <v-icon size="24" class="mr-0" color="greyTint" v-else>
              {{ item.icon }}
            </v-icon>
          </template>

          <template v-slot:activator>
            <v-list-item-content>
              <v-badge v-if="item.badge" content="New" color="secondary">
              </v-badge>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-show="!item.type" v-for="(child, i) in item.children" :key="i"
            :to="child.link ? child.link : ''" link class="pl-12"
            @click="child.action ? child.action() : Redirigir(child)">
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-tooltip right v-if="!DRAWER_STATE">

                <template v-slot:activator="{ on, attrs }">
                  <v-icon size="" v-bind="attrs" v-on="on">{{ child.icon }}</v-icon>
                </template>
                <span> {{ child.title }}</span>
              </v-tooltip>
              <v-icon size="" v-else>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-if="item.type">
            <v-list-group v-for="(item, i) in item.children" :key="i" :value="true" no-action sub-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="(child, i) in item.children" :key="i" link>
                <v-list-item-title>{{ child.title }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list-group>
        <v-list-item color="primary" v-else :key="item.text" :href="item.href ? item.href : null"
          :to="item.link === '#' ? '' : item.link" @click="item.action ? item.action() : Redirigir(item)" link>
          <v-list-item-action class="mr-6">
            <v-tooltip right v-if="!DRAWER_STATE">

              <template v-slot:activator="{ on, attrs }">
                <v-icon :size="item.size ? item.size : 24" :color="item.color ? item.color : 'greyTint'" v-bind="attrs"
                  v-on="on">{{ item.icon }}</v-icon>
              </template>
              <span> {{ item.title }}</span>
            </v-tooltip>
            <v-icon :size="item.size ? item.size : 24" :color="item.color ? item.color : 'greyTint'" v-else>{{ item.icon
              }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title link>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import MetodosLocales from "@/utils/managerLocalStorage.js";
export default {
  props: {
    source: String,
  },
  data() {
    return {
      tableroGD: false,
      items: [
        {
          title: "Principal",
          icon: "mdi-home",
          link: { name: "index" },
          order: 1
        },
        {
          title: "Búsqueda Avanzada",
          icon: "mdi-magnify",
          link: { name: "busquedaAvanzada" },
          order: 3
        },
        //{
        //    title: "Categorias Favorito",
        //    icon: "mdi-ticket",
        //    link: { name: "Favorito" },
        //},
      ],
      sidebarWidth: 280,
      sidebarMinWidth: 90,
      isMobile: false
    };
  },
  computed: {
    ...mapState({ drawer: (state) => state.drawer }),
    //...mapState(["domain", "informationPage"]),
    ...mapState(["user", "permission", "informationPage", "domain"]),
    ...mapGetters(["getUser"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
      set(newValue) {
        if (newValue === this.drawer) return;
        this.TOGGLE_DRAWER();
      },
    },

  },
  created() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapActions(["TOGGLE_DRAWER"]),
    handleResize() {
      this.isMobile = window.innerWidth <= 600; // Considera móvil a dispositivos con un ancho de pantalla menor o igual a 600px
    },
    logOut: function () {
      window.localStorage.setItem("authenticated", false);
      window.localStorage.removeItem("token");
      this.$router.push("/login");
    },
    async Redirigir(d) {
      let changeTime = window.sessionStorage.getItem("CambioContraseña");
      if (changeTime == 0 || changeTime == -1) {
        this.$router.push({ name: "Perfil" }).catch(error => error);
      } else {
        if (d.title != 'Líderes') {
          MetodosGenerales.deleteSession("LiderPantalla");
          //document.removeEventListener('visibilitychange', this.visibilitychange);
        }
        if (d.title == 'Finanzas Web') {
          await MetodosLocales.addSingleLocalStorage(this.getUser.get(this.permission.global).uslogin, this.informationPage.nameLocalStorageFinanzas);
          window.open(this.domain.domainNameDev + "finanzas/index", '_blank');
        } else if (d.title == 'Clientes') {
          window.open(this.domain.domainNameDev + "Clientes", '_blank');
        } else if (d.title == 'Cap Web') {
          window.open(this.domain.domainNameDev + "CAPWeb", '_blank');
        }

      }
    },
    ObtenerMenu(listaPermisos) {
      let clientesItems = [];
      let vacacionesItems = [];
      let finanzasItems = [];
      let capWebItems = [];
      let vacacionesplus = [];

      listaPermisos.forEach(permiso => {
        switch (permiso.Peclave) {
          case 70:
            this.items.push({ title: "Blog", icon: "mdi-book-open-page-variant", link: { name: 'BlogAdmin' }, order: 13 });
            break;
          case 358:
            this.items.push({ title: "WhatsApp", icon: "mdi mdi-whatsapp", link: { name: 'MisPendientesWhatsApp' }, order: 15 });
            break;
          case 28: case 289: case 347:
            if (permiso.Peclave == 28) {
              this.items.push({ title: "Operaciones", icon: "mdi-tie", children: [], order: 5 });
              const OperacionesItem = this.items.find(item => item.title === "Operaciones");
              OperacionesItem.children.push({ title: "Expedientes Juridicos", icon: "mdi-chart-bar", link: { name: "Menu" }, });
            }
            else if (permiso.Peclave == 289) {
              const OperacionesItem = this.items.find(item => item.title === "Operaciones");
              OperacionesItem.children.push({ title: 'Tablero', icon: 'mdi-trello', link: { name: "tablero" }, });
            }
            else if (permiso.Peclave == 347) {
              const OperacionesItem = this.items.find(item => item.title === "Operaciones");
              OperacionesItem.children.push({ title: "Dashboard", icon: "mdi-ballot-outline", link: { name: "Dashboard" }, });
            }
            break;
          case 332:
            this.items.push({ title: "Gestoria Documental", icon: "mdi-locker-multiple", link: { name: "indexGD" }, order: 7 });
            break;
          case 335:
            this.items.push({ title: "Pago Proveedor", icon: "mdi-account-cash", link: { name: "Inicio" }, order: 10 });
            break;
          case 40:
            this.items.push({ title: "Líderes", icon: "mdi-binoculars", link: { name: "LideresMain" }, order: 4 });
            break;
          case 15:
            this.items.push({ title: "Contraloria Normativa", icon: "mdi-eye", link: { name: "MenuRecuperaciones" }, order: 8 });
            //this.items.push({ title: "Contraloria Normativa", icon: "mdi-eye", });
            //this.items.push({ title: "Contraloria Normativa2", icon: "mdi-eye", link: { name: "MenuRecuperaciones" }, });
            break;
          case 12: case 296:
            if (permiso.Peclave == 12) {
              this.items.push({ title: "Calidad", icon: "mdi-clipboard-check", children: [], order: 9 });
              const calidadItem = this.items.find(item => item.title === "Calidad");
              calidadItem.children.push({ title: 'Realizar encuesta', icon: 'mdi-file-question', link: { name: "RealizarEncuesta" }, });
              calidadItem.children.push({ title: 'Encuestas contestadas', icon: 'mdi-file-check', link: { name: "EncuestasContestadas" } });
              calidadItem.children.push({ title: 'Indicador Encuesta', icon: 'mdi-file-chart', link: { name: "EstadisticaEncuesta" } });
              calidadItem.children.push({ title: 'Calificar Agentes', icon: 'mdi-face-agent', link: { name: "CalificarAgentes" } });
              calidadItem.children.push({ title: 'Mis pendientes Encuestas', icon: 'mdi-clock-alert', link: { name: 'MisPendientesNPS' }, });
            }
            else if (permiso.Peclave == 296) {
              const calidadItem = this.items.find(item => item.title === "Calidad");
                calidadItem.children.push({ title: 'Indicador de NPS Mensual', icon: 'mdi-file-alert', link: { name: 'EstadisticaNPS' }, });
            }
            break;
          case 208:
            this.items.push({ title: "Quejas", icon: "mdi-thumb-down", link: { name: "LevantarQueja" }, order: 11 });
            break;
          case 60:
            //this.items.push({ title: "Sistemas", icon: "mdi-database", order: 10 });
            this.items.push({ title: "Sistemas", icon: "mdi-database", link: { name: "Sistemas" }, order: 12 });
            break;
          case 171:
            capWebItems.push({ title: "Cap Web", icon: "mdi-account-group", link: "", });
            break;
          case 295: case 172:
            if (permiso.Peclave == 172) {
              if (!finanzasItems.length) {
                finanzasItems.push({ title: "Finanzas", icon: "mdi-cash", children: [] });
              }
              const finanzasItem = finanzasItems.find(item => item.title === "Finanzas");
              finanzasItem.children.push({ title: 'Finanzas Web', icon: 'mdi-web', fuera: true, link: "", });
            }
            else if (permiso.Peclave == 295) {
              if (!finanzasItems.length) {
                finanzasItems.push({ title: "Finanzas", icon: "mdi-cash", children: [] });
              }
              const finanzasItem = finanzasItems.find(item => item.title === "Finanzas");
              finanzasItem.children.push({ title: 'Admin. Contrarecibos', icon: 'mdi-file-download-outline', link: { name: 'AdminContrarecibo' }, });
            }
            break;
          case 224:
            clientesItems.push({ title: "Clientes", icon: "mdi-home-group" });
            break;
          case 376:
            this.items.push({ title: "Pre Alta", icon: "mdi-account-plus", link: { name: "Pre_Alta" }, order: 14 });
            break;
          case 294: case 319:
            if (permiso.Peclave == 294) {
              if (!vacacionesItems.length) {
                vacacionesItems.push({ title: "Vacaciones", icon: "mdi-airplane-takeoff", children: [] });
              }
              const vacacionesItem = vacacionesItems.find(item => item.title === "Vacaciones");
              vacacionesItem.children.push({ title: "Solicitud Vacaciones", icon: "mdi-clipboard-text-outline", link: { name: "SolicitarVacaciones" } });

            } else if (permiso.Peclave == 319) {
              if (!vacacionesItems.length) {
                vacacionesItems.push({ title: "Vacaciones", icon: "mdi-airplane-takeoff", children: [] });
              }
              const vacacionesItem = vacacionesItems.find(item => item.title === "Vacaciones");
              vacacionesItem.children.push({ title: "Autorizar Vacaciones", icon: "mdi-clipboard-check-multiple-outline", link: { name: "AutorizarVacaciones" } });

            }
            break;
          case 386:
            this.items.push({ title: "Carga Walmart", icon: "mdi-file-upload", link: { name: "CargaMasivaCivil" }, order: 6 });
            break;
        }
      })
      this.items.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
      this.items = this.items.concat(capWebItems, finanzasItems, clientesItems, vacacionesItems, vacacionesplus);

    }
  },
  async mounted() {
    /*Obtener permisos */
    let permisos = await MetodosGenerales.ObtenerPermisosGenerales(0);

    await MetodosGenerales.Asistencia().then((response) => {
      if (response == 1) {
        this.items.splice(1, 0, { title: "Asistencia", icon: "mdi-account-check", link: { name: 'Asistencia' }, order: 2 });
      }
    });
    if (permisos && permisos.length > 0) {
      this.ObtenerMenu(permisos);
    } else {
      let permisos = await MetodosGenerales.ObtenerPermisosGenerales(1);
      this.ObtenerMenu(permisos);
    }

  },
};
</script>

<style src="@/views/shared/sidebar/Sidebar.scss" lang="scss" />
